import PageButton, { PageButtonDirection } from 'components/PageButton';
import React, { useState } from 'react';
import { scrollToSection } from 'utils/common';
import styles from './PaginatedList.module.css';

export interface PaginatedListProps<T> {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  itemsPerPage?: number;
}

export function PaginatedList<T>({
  items,
  renderItem,
  itemsPerPage = 6,
}: PaginatedListProps<T>) {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(items.length / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const currentItems = items.slice(startIdx, startIdx + itemsPerPage);

  const additionalOffset = -25;
  return (
    <div className={styles.container}>
      <div id={'top'}></div>
      <div className={styles.grid}>
        {currentItems.map((item, index) => (
          <div key={index}>{renderItem(item)}</div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <div className={styles.buttonContainer}>
            <PageButton
              pageButtonDirection={PageButtonDirection.PREVIOUS}
              disabled={currentPage === 1}
              onClick={() => {
                setCurrentPage(currentPage - 1);
                scrollToSection('#top', additionalOffset);
              }}
            />
            <PageButton
              pageButtonDirection={PageButtonDirection.NEXT}
              disabled={currentPage >= totalPages}
              onClick={() => {
                setCurrentPage(currentPage + 1);
                scrollToSection('#top', additionalOffset);
              }}
            />
          </div>
          <span className={styles.pageNumber}>
            Page {currentPage} / {totalPages}
          </span>
        </div>
      )}
    </div>
  );
}
